import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 32,
  },
  message: {
    marginBottom: 64,
    textTransform: 'uppercase',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  button: {
    maxWidth: 300,
  },
}));
